export enum ProductType {
  requirement = 'requirement',
  change = 'change',
  law = 'law'
}
